import { render } from "./Footer.vue?vue&type=template&id=c67aa352&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=c67aa352&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3929609420/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c67aa352"]])

export default __exports__